import { combineReducers } from 'redux';
import mqtt from './mqtt';
import navigation from "./navigation"

export default combineReducers({
  state: () => true,
  mqtt,
  navigation
});



// WEBPACK FOOTER //
// ./src/modules/index.js